import PL_MESSAGE from './pl_message/index.js';
// import PL_MYORDER from './pl_myorder/index.js'
import GLB_VALID from './glb_valid';
import GLB_SCROLL from './glb_scroll';
import Pl_ERRHANDLE from './pl_errhandle';
import Pl_FLOATMENU from './pl_floatmenu';
import GLB_FUNC from './glb_function';
import GLB_TIMESTAMP from './glb_timeStamp';
import GLB_DECIMAL2 from './glb_decimal2';
import floatmenu from '@/components/floatmenu';
import footer from '@/components/footer';
import Consultingmaster from '@/components/Consulting_master.vue';

// 解决 axios 低版本浏览器兼容问题
// import "babel-polyfill";
import promise from 'es6-promise';
promise.polyfill();

import api from '../api/index.js';
import Router from 'vue-router';

const plugins = (Vue, App) => {
  Vue.use(Router);
  var router = new Router({ mode: 'history' }); // history是为了去掉 .html #/ 问题
  // 解决翻页后 位置问题 t
  router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
  });
  // 解决翻页后 位置问题 b
  const MyPlugins = {
    install: function (Vue) {
      const $Glb = (Vue.prototype['$Glb'] = {});

      // 验证
      GLB_VALID($Glb, Vue);

      // 滚动
      GLB_SCROLL($Glb, Vue);

      // 全局零散方法
      GLB_FUNC($Glb, Vue);

      // 时间戳转几分钱 几秒前
      GLB_TIMESTAMP($Glb, Vue);

      // 消息提示
      PL_MESSAGE($Glb, Vue);

      // 我的订单按钮
      // PL_MYORDER( $Glb , Vue );

      //数值保留为2位小数
      GLB_DECIMAL2($Glb, Vue);

      // 全局错误处理及公共组建
      Vue.component('PluErrHandle', Pl_ERRHANDLE);

      // 首页悬浮菜单
      Vue.component('PluFloatMenu', Pl_FLOATMENU);

      //浮动菜单和footer - 统一，新建 jurieo
      Vue.component('floatmenu', floatmenu);
      Vue.component('hfooter', footer);
      Vue.component('Consultingmaster', Consultingmaster);
    },
  };
  Vue.use(MyPlugins);

  Vue.prototype.$api = api;

  Vue.config.productionTip = false;

  Vue.prototype.$getWxPhone = function (info) {
    return new Promise((resove, reject) => {
      let data = {
        goodsid: info.goodsid,
        page: info.page, // 1（首页）， 2（详情页），3（未解锁页）
        cid: info.cid,
        isWnl: 2,
      };
      this.$api.post('/v1/ContactConfigure/getContactConfigure', data, (res) => {
        resove(res);
      });
    });
  };

  // 把vue的方法设置到全局
  window.$Vue = Vue.prototype;

  //// 用户点击统计
  //try {
  //  window.addEventListener('click', (e) => {
  //
  //    var info = e.target.getAttribute('data-text')
  //
  //    if (info !== null) {
  //      console.log(info)
  //      window.$Vue.$api.post('/v1/test')
  //    }
  //  })
  //} catch (error) {
  //
  //}

  /* 自定义埋点指令
   * param是使用指令时需要传入的参数
   * 使用指令时，在按钮上填入v-burypoint="{'events':xxx,'page':'index':xxx,'isChildComponents':true,'oldPropName':'xxx'}
   * events:填入是哪个按钮触发的，只需填首字母
   * index:有三个值：index、detail、unlock分别表示首页，详情页，解锁页
   * isChildComponents:是否是其它页面需要引用的组件，即是否是子组件，如果不是，则不用填写
   * */
  Vue.directive('burypoint', {
    bind: function (el, param, vnode) {
      el.addEventListener('click', function () {
        var ua = navigator.userAgent;
        var nowDevice = ''; //当前机型
        if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
          nowDevice = 'a'; //安卓
        } else if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          nowDevice = 'i'; //IOS
        } else {
          nowDevice = 'o';
        }
        var nowData = param.value; //指令传过来的参数
        //首页渠道id是channel，其它的是cid
        var nowCid = null;
        var oldDataName = nowData.oldPropName; //当前页面channel渠道ID的属性名
        if (oldDataName) {
          if (nowData.isChildComponents) {
            //是否是子组件
            nowCid =
              nowData.page === 'index' ? vnode.context.$parent[oldDataName].channel : vnode.context.$parent[oldDataName].cid;
          } else {
            nowCid = nowData.page === 'index' ? vnode.context[oldDataName].channel : vnode.context[oldDataName].cid;
          }
        } else {
          if (nowData.isChildComponents) {
            //是否是子组件
            nowCid = nowData.page === 'index' ? vnode.context.$parent.apiData.channel : vnode.context.$parent.apiData.cid;
          } else {
            nowCid = nowData.page === 'index' ? vnode.context.apiData.channel : vnode.context.apiData.cid;
          }
        }

        console.log(nowData.page);
        console.log(nowData.events);
        console.log(nowCid);
        window.$Vue.$api.get(
          'v1/BuriedPoints/record',
          {
            device: nowDevice,
            cid: nowCid,
            page: nowData.page,
            event: nowData.events,
          },
          (res) => {
            console.log(res);
          }
        );
      });
    },
  });

  /*
   * 自定义pc适配指令
   * el：绑定的元素,即需要修改位置的元素。
   * binding：指令传过来的值
   * 使用：v-fixpos='{pos:"right",default:"0.4rem"}'
   * pos：当前fixed定位的元素设置的是left还是right值，只有这两个值
   * default：在适配前，该元素left或者right的初始值，一定要带单位
   * */
  Vue.directive('fixpos', {
    bind: function (el, binding) {
      setItemPos(el, binding);
      window.addEventListener('resize', function () {
        setItemPos(el, binding);
      });
    },
  });
  //修改元素位置
  function setItemPos(el, binding) {
    let win_w = document.documentElement.clientWidth;
    let offval = binding.value.default; //偏移初始值
    let offset = binding.value.pos; //偏移方向
    if (win_w > 750) {
      let new_wid = win_w > 750 ? 750 : win_w;
      let realNum = 0; //传过来的偏移值的数值
      let newOffset = 0; //修正过的数值，单位为px
      let gap = (win_w - new_wid) / 2; //表示当前html距离浏览器左右两边的宽度是多少，单位为px
      if (offval.indexOf('rem') !== -1) {
        //单位带有rem
        realNum = offval.split('rem')[0];
        newOffset = realNum * 100 + gap;
      } else if (offval.indexOf('px')) {
        //单位带有px
        realNum = offval.split('px')[0];
        newOffset = realNum + gap;
      }
      el.style[offset] = newOffset + 'px';
    } else {
      el.style[offset] = offval; //如果小于750，就设置为原来的默认值
    }
  }

  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App },
  });
};

export default plugins;



// WEBPACK FOOTER //
// ./src/plugins/index.js